import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'
import './App.css'
import { Book } from './Book.js'
import { Home } from './Home.js'
import { Contact } from './Contact.js'
import { Pricing } from './Pricing.js'
import { Themes } from './Themes.js'

function App () {
  return (
    <div className='App'>
      <Router>
        <Routes>
          <Route path='/' element={<Home />} />
          <Route path='/book' element={<Book />} />
          <Route path='/contact' element={<Contact />} />
          <Route path='/pricing' element={<Pricing />} />
          <Route path='/themes' element={<Themes />} />
        </Routes>
      </Router>
    </div>
  )
}

export default App
